function readStaticHost(): string {
  const appConfigHost = String((window as any).APP_CONFIG?.static_host_url || '').trim().replace(/\/+$/, '');
  if (appConfigHost) return appConfigHost;

  const appSettingsHost = String((window as any).APP_SETTINGS?.static_host_url || '').trim().replace(/\/+$/, '');
  if (appSettingsHost) return appSettingsHost;

  throw new Error('static_host_url no está definido en APP_CONFIG/APP_SETTINGS');
}

export function getStaticHostUrl(): string {
  return readStaticHost();
}

export function toAbsoluteStaticUrl(path: string): string {
  const host = readStaticHost();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  try {
    return new URL(normalizedPath, host).toString();
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`No se pudo construir URL estática absoluta: ${error.message}`);
    }
    throw error;
  }
}
